export default __webpack_public_path__ + "static/media/card-master.9957a801.svg";